import React from "react";
import HeaderOne from "./HeaderOne";
import FooterOne from "./FooterOne";

const RefundPolicy = () => {
  document.title = "Refund & Cancellation Policy | MordenBazaar";

  return (
    <>
      <HeaderOne />

      <div className="page-content pt-0">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 col-xl-8">

              <h1 className="mt-4 mb-4">Refund, Cancellation & Return Policy</h1>

              {/* 1 */}
              <h2 className="mt-5 mb-3">1. Cancellation Policy</h2>
              <ul className="list-disc pl-5 mb-4 space-y-3">

                <li>
                  <strong>Customer Cancellation (Before Dispatch)</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>You may cancel your order anytime before dispatch without any charges.</li>
                  </ul>
                </li>

                <li>
                  <strong>Customer Cancellation (After Dispatch)</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>If cancelled after dispatch or refused at delivery, a 10% cancellation fee will be deducted.</li>
                  </ul>
                </li>

                <li>
                  <strong>How to Cancel an Order</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Login → My Orders → Cancel Order.</li>
                    <li>Or contact customer support via email or phone.</li>
                  </ul>
                </li>

                <li>
                  <strong>Seller-Initiated Cancellation</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>If cancelled due to stock or technical issues, a full refund will be issued.</li>
                  </ul>
                </li>

                <li>
                  <strong>Refund Timelines</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Eligible refunds are processed within 3 working days to the original payment method.</li>
                  </ul>
                </li>

              </ul>

              {/* 2 */}
              <h2 className="mt-5 mb-3">2. Return, Exchange & Replacement Policy</h2>
              <ul className="list-disc pl-5 mb-4 space-y-3">

                <li>
                  <strong>Return Window</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Returns must be requested within 3 days of delivery.</li>
                  </ul>
                </li>

                <li>
                  <strong>Eligibility Criteria</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Items must be unused, unwashed, unstitched, and include original tags and packaging.</li>
                  </ul>
                </li>

                <li>
                  <strong>Product Exclusions</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>No product categories are excluded currently.</li>
                    <li>If exclusions are added, the policy will be updated.</li>
                  </ul>
                </li>

                <li>
                  <strong>Required Proof</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Invoice and unboxing video are mandatory for damaged or incorrect items.</li>
                  </ul>
                </li>

                <li>
                  <strong>Return Shipping</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>We arrange pickup and cover return shipping costs.</li>
                    <li>A 10% cancellation fee applies for both change-of-mind and defective returns.</li>
                  </ul>
                </li>

                <li>
                  <strong>How to Initiate a Return</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Login → My Orders → Return.</li>
                    <li>Email customer support at support@mordenbazaar.com.</li>
                  </ul>
                </li>

                <li>
                  <strong>Return Outcomes</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li><strong>Exchange:</strong> Choose another product.</li>
                    <li><strong>Replacement:</strong> Same product (subject to availability).</li>
                    <li><strong>Refund:</strong> Processed within 3 working days after inspection.</li>
                  </ul>
                </li>

                <li>
                  <strong>Inspection & Ineligible Returns</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Used, washed, damaged, or incomplete items will be returned without refund.</li>
                  </ul>
                </li>

                <li>
                  <strong>Damaged or Wrong Products</strong>
                  <ul className="list-disc pl-6 mt-2 space-y-1">
                    <li>Must be reported within 3 days of delivery with proof.</li>
                  </ul>
                </li>

              </ul>

              {/* 3 */}
              <h2 className="mt-5 mb-3">3. General Conditions</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>This policy may be updated from time to time.</li>
                <li>Please ensure secure packaging during pickup.</li>
                <li>Refund status can be tracked via your account or customer support.</li>
              </ul>

              {/* 4 */}
              <h2 className="mt-5 mb-3">4. Customer Support</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li><strong>Email:</strong> support@mordenbazaar.com</li>
                <li><strong>Phone:</strong> +91-XXXXXXXXXX</li>
                <li>You can also visit the “My Orders” section in your account.</li>
              </ul>

              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li><em>No special exclusions apply during festival sales or limited editions.</em></li>
                <li><em>If Open-Box Delivery is introduced, this policy will be updated.</em></li>
              </ul>

            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default RefundPolicy;